import { z } from 'zod';
import superjson from 'superjson';
export const schema = z.object({
  prompt: z.string().min(10).max(2000),
  category: z.string().min(1).max(50).optional(),
  basedOn: z.string().optional(), // Optional persona ID to use as a base
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  persona: {
    id: string;
    name: string;
    description: string | null;
    icon: string;
    category: string;
    systemPrompt: string;
    isBuiltin: boolean;
    priority: number;
    tags: string[] | null;
    visibility: string;
    source: string;
  };
};

export const postGeneratePersona = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const result = await fetch('/_api/personas/generate', {
    method: 'POST',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    body: superjson.stringify(input),
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};
